export default {
	es: {
		"Titulo home": "A Jaén. A tu paraíso",
		"Intro actividades": "Actividades gratuitas para que vivas Jaén<br> como nunca lo habías hecho",
		"Imagen intro home": "/static/img/background-intro.jpg",
		"Titulo buscador home": "Permanece atento a las programación de nuevas actividades.",
		"Cuerpo buscador home": "Todas las actividades se desarrollarán atendiendo la normativa sanitaria marcada por la Covid-19.",
		"A Jaén": "A Jaén",
		"Categoria Castillos Imagen" : "/static/img/castillos-banner-home.png",
		"Categoria Castillos Logo" : "/static/img/logo-castillos-y-batallas.svg",
		'Como inscribirse': "¿Cómo inscribirte a estas actividades?",
		"Titulo inscribirse 1": "Inscríbete gratis",
		"Cuerpo inscribirse 1": "<p>En un máximo de dos actividades por semana y, si son en el mismo día, una en horario de mañana, y otra en el de tarde.</p><p>Después de inscribirte recibirás un correo informando que la solicitud ha sido recibida, pero el proceso de inscripción no finaliza hasta que recibas un segundo correo de confirmación.</p><p>Las inscripciones se atenderán por orden de llegada hasta completar aforo.</p>",
		"Imagen inscribirse 1": "/static/img/icon-inscribete.svg",
		"Titulo inscribirse 2": "Dónde inscribirse",
		"Cuerpo inscribirse 2": "<p>Puedes hacerlo en esta web o por correo electrónico: <a class='enlace-listado home' href='mailto:infoturismo@dipujaen.es'>inforturismo@dipujaen.es</a></p><br><p> Más información: centro de Dinamización Turística de la provincia de Jaén. Tfno: 953 303 572 </p>",
		"Imagen inscribirse 2": "/static/img/icon-donde-inscribirse.svg",
		"Titulo inscribirse 3": "¿Cuándo inscribirte?",
		"Cuerpo inscribirse 3": "<p>Hasta 24 horas antes de su realización. Salvo en de actividades programadas en fin de semana, en cuyo caso concluye a las 12 horas del viernes anterior.<strong class='negrita-home'> La inscripción para cada actividad se abrirá 15 días antes de la fecha de celebración.</strong></p>",
		"Imagen inscribirse 3": "/static/img/icon-cuando-inscribirse.svg",
		"Titulo como inscribirse": "A Jaén",
		"Subtitulo como inscribirse": "A vivir experiencias",
		"Imagen como inscribirse": "/static/img/intro-como-inscribirse.jpg",
		"Como inscribirse titulo": "¿Cómo inscribirte a estas actividades?",
		"Tip inscribirse 1 imagen": "/static/img/icon-inscribete-inscrito.svg",
		"Tip inscribirse 1 titulo": "Inscríbete en las actividades / experiencias que quieras.",
		"Tip inscribirse 1 cuerpo": "Puedes hacerlo por estas vías:",
		"Tip inscribirse 1 telefono imagen": "/static/img/telefono.svg",
		"Tip inscribirse 1 telefono texto": "Por teléfono: llamando al <a href='tel:953303572'>953 303 572</a>. El horario es de 9 a 14 y de 17 a 19:30 hrs.",
		"Tip inscribirse 1 web imagen": "/static/img/webjaen.svg",
		"Tip inscribirse 1 web texto": "En la web <a href='https://ajaen.jaenparaisointerior.es/' target='_blank'>ajaen.jaenparaisointerior.es/</a></li>",
		"Tip inscribirse 1 alojamiento imagen": "/static/img/world.svg",
		"Tip inscribirse 1 alojamiento texto": "A través de tu alojamiento. Comunícaselo y se encargarán de toda la gestión.",
		"Tip inscribirse 2 imagen": "/static/img/icon-cuando-inscribirse-inscrito.svg",
		"Tip inscribirse 2 titulo": "¿Cuándo inscribirte?",
		"Tip inscribirse 2 cuerpo": `Las inscripciones se realizan por orden de llegada y es posible realizarlas desde el comienzo de este
		programa hasta 24 horas antes de su realización. Salvo en de actividades programadas en fin de semana, en
		cuyo caso concluye a las 12 horas del viernes anterior. Sujeto a disponibilidad.`,
		"Tip inscribirse 3 titulo": "No olvides que es obligatorio acudir a la actividad con mascarilla y respetar todas las indicaciones de seguridad",
		"Tip inscribirse 3 imagen": "/static/img/icon-mascarilla.svg",
		"Tips inscribirse ayuda": `*Para las actividades de Viaje al Tiempo de los íberos, puedes utilizar el Bus de los Íberos
		para desplazarte gratis desde Jaén capital a cualquiera de las actividades siempre que lo reserves a la vez
		que te inscribes.`,
		"Experiencias": "Experiencias",
		"Titulo Castillos": "Noches de Luz",
		"Subtitulo Castillos": "en los castillos de Jaén",
		"Cuerpo castillos": "El programa Noches de Luz en los Castillos de Jaén te traslada los meses de julio y agosto a vivir experiencias únicas en distintos municipios que componen esta ruta con actividades singulares donde sumergirte en este itinerario turístico que aúna la belleza del paisaje y el interés histórico, artístico y patrimonial de la provincia de Jaén.<br<br>La tercera edición de Noches de Luz en los castillos de Jaén ofrece un completísimo programa de actividades nocturnas en enclaves únicos que acogerán experiencias visuales y sensitivas donde la música, la magia, el circo, la danza, el fuego, la observación de estrellas y la recreación histórica se dan la mano a la tenue luz de las velas. Noches de luz es un soplo de aire fresco que pretende convertirse en un referente turístico y cultural de las calidad noches de verano de la Provincia de Jaén.",
		"Titulo Reino": "Un reino vivo",
		"Subtitulo Reino": "Experiencias únicas",
		"Cuerpo Reino": "<strong>Un reino de turismo activo, gastronómico, cultural y de naturaleza está en juego y no deberías perdértelo.</strong> Además de la programación de Noches de Luz en los Castillos de Jaén, te invitamos a vivir experiencias únicas en los distintos municipios que componen esta ruta con actividades singulares donde sumergirte en este itinerario turístico que aúna la belleza del paisaje y el interés histórico, artístico y patrimonial de la provincia de Jaén. El amplio programa de actividades que comienza en el mes de julio hasta final de año y está diseñado para todos los públicos, incluye fiestas y recreaciones históricas en castillos únicos en el mundo, música en directo, ciclos de cine, teatro, actividades de scape room o astroturismo, degustaciones gastronómicas, visitas guiadas tematizadas, talleres infantiles o exposiciones temáticas; entre otras actividades. Un sinfín de experiencias turísticas que complementarán tu visita a la provincia con mayor concentración de castillos y fortalezas de Europa.",
		"Titulo Fiestas": "Fiestas",
		"Subtitulo Fiestas": "y recreaciones históricas",
		"Cuerpo Fiestas": `<p>Nuestro viaje puede programarse para coincidir con algunas de las fiestas y recreaciones históricas que se programan en diferentes momentos del año, llenando la provincia de historia, patrimonio, cultura, divulgación y diversión. Experiencias turísticas para vivir aventuras inolvidables y descubrir el patrimonio singular de los 26 municipios que componen la Ruta de los Castillos y las Batallas de Jaén.</p><br><p>Apunta en tu calendario las principales fiestas programadas para disfrutar de este itinerario turístico que recorre toda la provincia:<br></p>`,
		"Listado Fiestas": ` <li><span>Fiestas ibero romanas de Cástulo. Mayo</span></li>
		<li><span>Fiestas del Medievo. Sabiote. Mayo</span></li>
		<li><span>Fiestas Calatravas de Alcaudete. Julio / agosto</span></li>
		<li><span>Villa del Trovador Macías en Arjonilla. Julio a septiembre</span></li>
		<li><span>Conmemoración de la Batalla de Navas de Tolosa. La Carolina. Julio</span></li>
		<li><span>Fiestas medievales de Porcuna. Julio</span></li>
		<li><span>Noche andalusí de la Rosa en Baños de la Encina. Julio</span></li>
		<li><span>Atardeceres en la frontera en Alcalá la Real. Julio</span></li>
		<li><span>Veladas nazaríes en Arjona. Julio</span></li>
		<li><span>Aniversario Villa de Torredelcampo. Mayo a septiembre</span></li>
		<li><span>Fiestas mediavales Vilches. Septiembre</span></li>
		<li><span>Fiestas mediavles "Castillo-Calatravo de Lopera". Septiembre</span></li>
		<li><span>Conmemoración de la batalla de Bailén. Octubre</span></li>
		<li><span>Fiesta medieval visigoda de Torredonjimeno. Octubre</span></li>
		<li><span>El viaje al mundo medieval en Martos. Octubre</span></li>
		<li><span>Jornadas medievales Canena y su castillo. Diciembre</span></li>
		`,
		"Ayuda Fiestas": "Toda la información de esta programación y todas las actividades que organizan los distintos municipios puedes encontrarla en la web <a class=`enlace-listado` href=`www.castillosybatallas.com/actividades`>www.castillosybatallas.com/actividades</a> y en las oficinas municipales de los distintos ayuntamientos que pertenecen a la Ruta de los Castillos y Batallas de Jaén.",
		"Cuando inscribirse Castillos": "¿Cuándo inscribirte?",
		"Cuerpo cuando inscribirse castillos": `Las inscripciones se confirman por orden de llegada y es posible realizarlas quince días antes del comienzo
		de la actividad, hasta 24 horas antes de su realización, salvo en actividades programadas en fin de semana,
		en cuyo caso concluye a las 12 horas del viernes anterior. Sujeto a disponibilidad. No olvides que es
		obligatorio
		acudir al evento con mascarilla y respetar todas las indicaciones de seguridad. Las actividades estarán
		sujetas a las restricciones sanitarias exigidas por las autoridades en el momento de la celebración del
		espectáculo.<br>
		<br>
		Estas instrucciones son exclusivamente para las inscripciones del Programa Noches de Luz en los Castillos de
		Jaén.<br>Para las actividades programadas en las fiestas y recreaciones históricas de la provincia, se
		realizarán las inscripciones y se resolverán las dudas en los respectivos ayuntamientos.`,
		"Folleto Castillos": "<span class='btn-negro'>Descargar Folleto actividades castillos y batallas</span>",
		"Folleto Castillos Link": "/static/pdf/Noches+de+Luz+en+Castillos+de+Jaén.pdf",
		"La ruta titulo": "La ruta",
		"La ruta subtitulo": "A Jaén a viajar a otra época",
		"La ruta imagen": "/static/img/mapa-castillos.png",
		"imagen footer 1": "/static/img/logo-diputacion.svg",
		"link footer 1": "https://www.dipujaen.es/",
		"imagen footer 2": "/static/img/logo-jaen-paraiso-interior.svg",
		"link footer 2": "http://jaenparaisointerior.es/",
		"imagen footer 3": "/static/img/logo-castillos-y-batallas.svg",
		"imagen footer 4": "/static/img/logo-iberos.svg",
		"imagen footer 5": "/static/img/logo-oleotour.svg",
		"imagen footer 6": "/static/img/cultura-del-toro.png",
		"imagen footer 7": "/static/img/logo-aventura.svg",
		"Más información" : "Más información: 953 303 572",
		"tel":"953303572",
		"Teléfono información" : "953303572",
		"texto pie 1" : "Andalucía",
		"link pie 1" : "https://www.andalucia.org/",
		"texto pie 2" : "Diputación de Jaén",
		"link pie 2" : "https://www.dipujaen.es/",
		"texto pie 3" : "Jaén Paraíso Interior",
		"link pie 3" : "http://jaenparaisointerior.es/",
		"texto pie 4" : "Aviso legal",
		"link pie 4" : "https://www.jaenparaisointerior.es/web/jaen-paraiso-interior/aviso-legal",
		categorias: {
			'resonancia-ibera': {
				encabezado: 'A transportarte a otra época',
				experiencia: 'Actividades gratuitas para descubrir la magia de una civilización.',
				cuerpo_experiencia: '<p>Te invitamos a vivir un verdadero viaje en el tiempo, el Viaje al Tiempo de los Íberos, una civilización mediterránea que se desarrolló durante los últimos siete siglos antes de nuestra era. <strong>La provincia de Jaén reúne un extraordinario patrimonio arqueológico de esa cultura</strong>, único en el mundo, con oppida (ciudades fortificadas), tumbas principescas, santuarios, conjuntos escultóricos, exvotos y cerámica propia de una sociedad aristocrática de príncipes, héroes, damas y diosas.</p><p>Después de <strong>más de 20 años trabajando en su recuperación</strong>, ahora puedes descubrir esa cultura misteriosa viviendo experiencias únicas en los yacimientos de la provincia de Jaén.</p>',
				others_images: "3",
				tituloruta: "Viaje al tiempo de los iberos",
				textoruta: `
				<ul>
					<li class="oppidum">Oppidum de Puente Tablas. Jaén</li>
					<li class="museo-ibero">Museo Íbero y Museo Provincial de Jaén</li>
					<li class="castulo">Ciudad de Cástulo y Museo Monográfico. Linares</li>
					<li class="toya">Tumbas Principescas de Toya y Hornos. Peal de Becerro</li>
					<li class="necropolis">Necrópolis Dinástica de Cerrillo Blanco. Porcuna</li>
					<li class="santuario">Santuario Ibérico de la Cueva de la Lobera. Castellar</li>
					<li class="giribaile">Ciudad fortificada de Giribaile. Vilches</li>
					<li class="ciclopea">Muralla Ciclópea. Ibros</li>
				<ul>
				`
			},
			'castillos-y-batallas': {
				encabezado: 'A viajar al pasado',
				experiencia: 'Atrévete a descubrir la magia que esconde la noche en los castillos de Jaén',
				cuerpo_experiencia: `
				<p>La Ruta de los Castillos y las Batallas que reune soberbios castillos situados en lugares estratégicos de extraordinaria belleza y evoca algunos de los episodios más importantes de la historia de la provincia de Jaén, ofrece múltiples actividades para sumergirte en estos escenarios de episodios trascendentales de la Península Ibérica. Entre estos paisajes, pueblos y ciudades tuvieron lugar dos batallas que cambiaron el orden político, social y económico de la España de entonces: la batalla de las Navas de Tolosa (1.212) y la de Bailén (1808).</p>
				<p>Te proponemos un regreso al pasado histórico que se fraguó en Jaén y que ha dejado más de 400 vestigios entre castillos, torres, fortalezas y alcazabas que nos convierten en un lugar único en todo el continente europeo.</p>`,
				others_images: "3",
				tituloruta: "De los Castillos y Batallas",
				textoruta: `<ul>
								<li>• Castillo de Baños de la Encina</li>
								<li>• Castillo de Santa Catalina, Jaén</li>
								<li>• Castillo de Alcaudete</li>
								<li>• Fortaleza de la Mota, Alcalá la Real</li>
								<li>• Castillo de Vilches</li>
								<li>• Castillo de Santa Eufemia (Cástulo), Linares</li>
								<li>• Castillo del Trovador Macías, Arjonilla</li>
								<li>• Aljibe del castillo de Arjona</li>
								<li>• Castillo de Lopera</li>
							</ul>`
			},
			'aventura': {
				encabezado: 'A sentir la adrenalina',
				experiencia: 'Actividades gratuitas para vivir experiencias únicas en sintonía con la naturaleza.',
				cuerpo_experiencia: `
				<p>Emocionantes <strong>experiencias deportivas vinculadas a los paisajes naturales de la provincia de Jaén.</strong> Descubre espacios singulares para practicar tu <strong>modalidad deportiva al aire libre</strong>. Actividades de bajo impacto ambiental que te harán protagonista de las mayores aventuras y las emociones más intensas que puedas imaginar.</p>
				<p><strong>¿Dispuesto a vivir aventuras inolvidables?</strong></p>
				<ul>
				<li>• Rutas guiadas en kayak por el Guadalquivi</li>
				<li>• Iniciación al Paddel Surf+ruta básica.</li>
				<li>• Descenso de barrancos.</li>
				<li>• Rafting en aguas bravas.</li>
				<li>• Paseos a caballo fuera de picadero.</li>
				<li>• Senderismo guiado de alta montaña estival modalidadcrepúsculo.</li>
				<li>• Viajes guiados en BTT, modalidad bikepacking.</li>
				<li>• Aventura por los senderos antiguos de la Sierra.</li>
				<li>• Rutas guiadas eBike/BTT de bajo impacto.</li>
				</ul>
				<p><strong>¡Y mucho más!</strong></p>
			`,
				others_images: "3"
			},
			'naturaleza': {
				encabezado: 'A respirar aire puro',
				experiencia: 'Disfruta de la riqueza natural de Jaén, de sus paisajes, de su flora, de su fauna.',
				cuerpo_experiencia: `
				<p>Ponemos a tu disposición una selección de actividades y experiencias especialmente pensadas para disfrutar de la naturaleza.</p>
				<p>Una oportunidad única de visitar los parques naturales de Jaén como nunca antes, descubriendo su riqueza natural, pero también histórica.</p>
				<p><strong>¿Qué actividades tienes a tu disposición?</strong></p>
				<ul>
				<li>• Vías ferratas</li>
				<li>• Rutas a pie</li>
				<li>• Rutas en 4x4</li>
				</ul>
				<p><strong>¡Y mucho más!</strong></p>
			`,
				others_images: "3"
			},
			'cultura-del-toro': {
				encabezado: 'A descubrir la tradición',
				experiencia: 'Actividades gratuitas relacionadas con la cultura del toro.',
				cuerpo_experiencia: `
				<p>El mundo del toro forma parte de la cultura tradicional de Jaén y, por ello, no podían faltar en nuestra selección de experiencias diversas actividades relacionadas con la cultura del toro. No te pierdas las visitas a ganaderías que hemos preparado para ti.</p>
			`,
				others_images: "3"
			},
			'visitas-culturales': {
				encabezado: 'A sorprenderte',
				experiencia: 'Actividades gratuitas para descubrir la belleza e historia de la provincia.',
				cuerpo_experiencia: `
				<p>Jaén posee un rico patrimonio cultural que la convierte en una provincia única que rebosa belleza e historia. Queremos acercarte todo ello para que disfrutes de la cultura de Jaén como nunca antes lo has hecho gracias a diferentes experiencias culturales de lo más variado en los enclaves más destacados de Jaén.</p>
				<p><strong>¿Qué actividades tienes a tu disposición?</strong></p>
				<ul>
				<li>• Rutas a pie</li>
				<li>• Rutas nocturnas</li>
				<li>• Rutas teatralizadas</li>
				<li>• Visitas guiadas</li>
				</ul>
				<p><strong>¡Y mucho más!</strong></p>
			`,
				others_images: "3"
			},
			'oleoturismo': {
				encabezado: 'A saborear',
				experiencia: 'Actividades gratuitas para sumergirse en la cultura del aceite.',
				cuerpo_experiencia: `
				<p>El aceite, nuestro oro líquido, uno de los tesoros más preciados de Jaén y admirados en todo el mundo. Te invitamos a conocer más sobre el aceite en una serie de actividades y experiencias únicas que te sumergen en el origen y la cultura del aceite: visitas a granjas, museos, degustaciones de aceites… ¡No te lo pierdas!</p>
			`,
				others_images: "3"
			}

		},
		enlaces: {
			actualidad: '/actualidad',
			sala_de_prensa: "/sala-de-prensa",
			categoria: "/experiencias",
			vivir_experiencias: '/vivir-experiencias',
			politica_privacidad: "/politica-de-privacidad",
			politica_cookies: "/politica-de-cookies",
			actividad: '/actividad',
			como_inscribirte: '/como-inscribirte',
			proximamente: '/proximamente',
			registro: '/registro',
			categorias: {
				naturaleza: '/naturaleza',
				iberos: '/iberos',
				aventura: '/aventura',
				culturatoro: '/cultura-del-toro',
				visitasculturales: '/visitas-culturales',
				oleoturismo: '/oleoturismo',
				'castillos-y-batallas': '/castillos-y-batallas'
			}
		},
		formulario: {
			nombre: "Nombre",
			nombre_apellidos: "Nombre y apellidos",
			apellidos: "Apellidos",
			email: "Email",
			mensaje: "Mensaje",
			fecha_nacimiento: "Fecha de nacimiento",
			dia: "Día",
			mes: "Mes",
			anyo: "Año",
			si: "Si",
			no: "No",
			carta_presentacion: "Carta de presentacion",
			meses: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
			archivo_adjunto: "Adjuntar archivo",
			adjuntar_cv: "Adjuntar CV",
			introduce_mail: "Introduce tu email",
			password: 'Contraseña',
			password_confirmation: 'Repetir contraseña',
			pais: "País",
			telefono: "Teléfono",
			he_leido: "He leído y acepto la",
			y_acepto: "política de privacidad",
			enviar: "Enviar",
			enviado: "Enviado",
		},

	},
	en: {
		enlaces: {
			actualidad: '/news',
			sala_de_prensa: "/press-room",
			contacto: "/contact",
			trabaja_con_nosotros: "/work-with-us",
			politica_privacidad: "/privacy-policy",
			politica_cookies: "/cookies-policy",
		}
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js